import React from 'react';
import DENTModalOverviewPeriodontalSelect from './DENTModalOverviewPeriodontalSelect';
import { getSideDependingPeriodontalObject } from '../../Helpers/periodontal/getSideDependingPeriodontalObject';
import DENTModalOverviewPeriodontalMobility from './DENTModalOverviewPeriodontalMobility';
import Button from '../../../../Components/Button/Button';
import styles from './DENTModalOverviewPeriodontal.module.scss';
import { useDENTContext } from '../../Services/DENTContext';
import useTooth from '../../Hooks/Tooth/useTooth';
import { OverviewMode } from '../../Enums/OverviewMode.enum';
import DENTModalOverviewPeriodontalFurcation from './DENTModalOverviewPeriodontalFurcation';
import { ToothType } from '../../../../graphql/graphql';
import DENTModalOverviewHeader from '../DENTModalOverviewHeader/DENTModalOverviewHeader';
import DENTToothQuickAdjustmentModalTitle from '../DENTToothQuickAdjustmentModal/DENTToothQuickAdjustmentModalTitle';
import usePeriodontalKeyboard from '../../Hooks/Tooth/Periodontal/usePeriodontalKeyboard';

interface Props {
	onClose: () => void;
}

const TITLE = 'patientTreatment.meddiDENT.dentalCross.periodontal.title';

const DENTModalOverviewPeriodontal = ({ onClose }: Props) => {
	const { handleUpdateTooth, activeTooth, overviewMode } = useDENTContext();

	const {
		periodontal: { getPeriodontal },
	} = useTooth();

	const submit = async () => {
		if (!activeTooth?.periodontal) return;

		handleUpdateTooth({
			periodontal: getPeriodontal,
		});
	};

	if (!activeTooth) return <></>;

	const periodontalObject = getSideDependingPeriodontalObject(
		getPeriodontal,
		activeTooth,
	);

	usePeriodontalKeyboard({ periodontalObject });

	const isQuickAdjustment = overviewMode === OverviewMode.PERIODONTAL;
	const showFurcation =
		!isQuickAdjustment &&
		(activeTooth.type === ToothType.Premolar ||
			activeTooth.type === ToothType.Molar);

	return (
		<div
			className={
				isQuickAdjustment ? styles.quickAdjustmentWrapper : styles.wrapper
			}>
			{isQuickAdjustment ? (
				<DENTToothQuickAdjustmentModalTitle title={TITLE} />
			) : (
				<DENTModalOverviewHeader title={TITLE} onClose={onClose} />
			)}
			<DENTModalOverviewPeriodontalSelect
				periodontalObject={periodontalObject}
			/>
			{showFurcation && <DENTModalOverviewPeriodontalFurcation />}
			{!isQuickAdjustment && <DENTModalOverviewPeriodontalMobility />}
			<div className={styles.button}>
				<Button title={'base.shared.form.send'} onClick={submit} />
			</div>
		</div>
	);
};

export default DENTModalOverviewPeriodontal;
